// src/components/wizard/StepIndicator.jsx - ステップ進捗インジケーター

import React from 'react';
import { COLORS, SPACING } from '../../styles/constants';

const StepIndicator = ({ currentStep, totalSteps }) => {
  const steps = [
    { number: 1, label: 'テーマ入力' },
    { number: 2, label: '確認・編集' },
    { number: 3, label: '投稿' }
  ];

  return (
    <div style={{
      padding: `${SPACING.lg} ${SPACING.md}`,
      background: COLORS.white
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '400px',
        margin: '0 auto'
      }}>
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            {/* ステップアイコン */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: SPACING.xs
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '700',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                ...(currentStep > step.number ? {
                  background: COLORS.successGradient,
                  color: COLORS.white,
                  boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)'
                } : currentStep === step.number ? {
                  background: COLORS.primaryGradient,
                  color: COLORS.white,
                  boxShadow: '0 6px 20px rgba(59, 130, 246, 0.5)'
                } : {
                  background: COLORS.gray200,
                  color: COLORS.gray500
                })
              }}>
                {currentStep > step.number ? '✓' : step.number}
              </div>
              <span style={{
                fontSize: '0.75rem',
                fontWeight: '500',
                color: currentStep >= step.number ? COLORS.gray900 : COLORS.gray400,
                transition: 'color 0.3s ease'
              }}>
                {step.label}
              </span>
            </div>

            {/* 接続線 */}
            {index < steps.length - 1 && (
              <div style={{
                flex: 1,
                height: '3px',
                margin: '0 0.5rem',
                marginBottom: '1.5rem',
                borderRadius: '2px',
                transition: 'background 0.3s ease',
                background: currentStep > step.number
                  ? COLORS.primaryGradient
                  : COLORS.gray200
              }} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
